import sjcl from 'sjcl'

const xorReduce = (data, length) => {
    const result = []
    for (var i = 0; i < data.length; i++) {
        const j = i % length
        if (result[j] === undefined) {
            result[j] = data[i]
        } else {
            result[j] = result[j] ^ data[i]
        }
    }
    return result
}

const base64Pass = (bits) => sjcl.codec.base64.fromBits(bits).replace(/=+$/,'').replace(/\+/, '-').replace(/\//, '.')

const decoratePass = (pass) => {
    const containsSpecial = pass.match(/[^a-zA-Z0-9]/) ? true : false
    const containsSmallLetters = pass.match(/[a-z]/) ? true : false
    const containsCapitalLetters = pass.match(/[A-Z]/) ? true : false
    const containsDigits = pass.match(/[0-9]/) ? true : false
    if (!containsSpecial) {
        pass += "."
    }
    if (!containsSmallLetters) {
        pass += "a"
    }
    if (!containsCapitalLetters) {
        pass +="A"
    }
    if (!containsDigits) {
        pass += "0"
    }
    return pass
}

export default (masterPassword, domain) => {
    const binHash = sjcl.hash.sha256.hash(domain + ":" + masterPassword)
    const binHashReduced = xorReduce(binHash, 4)
    return decoratePass(base64Pass(binHashReduced))
}
